import React from 'react';
import '../css/FlightNumber.css';

const FlightNumber = ({ id }) => {
  return (
    <div className="flight-number-container">
      <span>FlightNumber</span>
      <div className="flight-number-box">
        <p>{id}</p>
      </div>
    </div>
  );
};

export default FlightNumber;